import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { EditableInterfaceComponent } from '../editable.types';
import { TagsModalComponent } from 'app/shared/modals/tags-modal/tags-modal.component';
import isArray from 'lodash-es/isArray';
import { PartialFormField } from '../../form-fields/form-field.types';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  templateUrl: './tags-editable.component.html',
  styleUrls: ['./tags-editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TagsEditableComponent extends OnDestroyMixin implements EditableInterfaceComponent, OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() meta: { origin: string };
  @Input() readonly: boolean = false;
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public options: any[];
  public value: string = '';
  public tags: string[] = [];
  foundTags: string[];
  public editing: boolean = false;
  private _originalValue;

  constructor(private _matDialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;

    if (this.value) this.tags = Array.isArray(this.value) ? this.value : this.value?.split(',');
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) this.readonly = this.fieldDef.meta.readonly;
  }

  edit() {
    if (!this.editing && !this.readonly) this.editing = true;
  }

  onSave() {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value ? this.value : [] });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  openEditTags(): void {
    this._matDialog
      .open(TagsModalComponent, {
        panelClass: 'mailbox-compose-dialog',
        data: { tags: this.tags },
      })
      .afterClosed()
      .pipe(untilComponentDestroyed(this))
      .subscribe((result) => {
        if (result && result.tags) {
          this.value = result.tags.join(',');
          this.onSave();
        }
      });
  }
}
